import { render, staticRenderFns } from "./Matchquestion.vue?vue&type=template&id=60fcc023&scoped=true"
import script from "./Matchquestion.vue?vue&type=script&lang=js"
export * from "./Matchquestion.vue?vue&type=script&lang=js"
import style0 from "./Matchquestion.vue?vue&type=style&index=0&id=60fcc023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcc023",
  null
  
)

export default component.exports